import http from 'hub-http/clients/apiClient';
import { BASE_URI_V3 } from '../../constants/ApiConstants';
import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import { create } from 'zustand';
import { useCallback } from 'react';
import { updateCache } from '../../utils/DataFetchingClientCache';
import produce from 'immer';
import { useAchievementByTrackId } from '../achievement';
import { GET_ALL_PROGRESS } from '../userProgress';
import getLang from 'LearningCenterUI/utils/getLang';
const UPDATE_AWARD_PERMISSION = registerMutation({
  fieldName: 'updateAwardPermission',
  fetcher({
    awardCode,
    shouldBePublic
  }) {
    return http.post(`${BASE_URI_V3}/award/update-permission`, {
      data: {
        awardCode,
        isPublic: shouldBePublic
      }
    });
  }
});
const useAwardPermissionUpdating = create(set => ({
  isUpdatingPermission: {},
  setIsUpdatingPermission: (awardCode, isUpdatingPermission) => set(produce(state => {
    state.isUpdatingPermission[awardCode] = isUpdatingPermission;
  }))
}));
export const useUpdateAwardPermission = (awardCode, shouldBePublic) => {
  const [mutate, {
    loading: updateAwardPermissionLoading,
    called: updateAwardPermissionCalled,
    error: updateAwardPermissionError
  }] = useMutation(UPDATE_AWARD_PERMISSION, {
    variables: {
      awardCode,
      shouldBePublic
    },
    update() {
      updateCache(GET_ALL_PROGRESS, allProgress => {
        const foundAssetIndex = allProgress.assetProgress.findIndex(asset => asset.award && asset.award.code === awardCode);
        if (foundAssetIndex !== undefined) {
          allProgress.assetProgress[foundAssetIndex].award.visibility = shouldBePublic ? 'PUBLIC' : 'PRIVATE';
        }
      }, {
        language: getLang()
      });
    }
  });
  const {
    isUpdatingPermission,
    setIsUpdatingPermission
  } = useAwardPermissionUpdating();
  const updateAwardPermission = useCallback(() => {
    setIsUpdatingPermission(awardCode, true);
    return mutate().then(data => {
      setIsUpdatingPermission(awardCode, false);
      return data;
    });
  }, [awardCode, mutate, setIsUpdatingPermission]);
  return [updateAwardPermission, {
    updateAwardPermissionLoading,
    updateAwardPermissionGlobalLoading: isUpdatingPermission[awardCode],
    updateAwardPermissionCalled,
    updateAwardPermissionError
  }];
};
export const useAwardByTrackId = trackId => {
  const {
    achievement
  } = useAchievementByTrackId(trackId.toString());
  if (!achievement) return null;
  const achievementTrack = achievement.tracks.find(track => track.id === trackId.toString());
  if (!achievementTrack) return null;
  return achievementTrack.award;
};